const MANUAL_WORK_TITLE = "Enter title manually";
const MANUAL_COMPANY_ADDRESS = "Enter address manually";

/**
 * User types the app files under "Merchant" — business contacts that trade
 * under a company of their own, as opposed to retail clients and staff.
 *
 * One source for a grouping that was previously spelled out as a hand-written
 * `||` chain in five places, which is how a new type gets added to the dropdown
 * and then quietly lands in no tab, with the wrong business form and a "Client
 * profile" heading. Mirrors `User::MERCHANT_GROUP_TYPES` on the backend, whose
 * search filters and validation rules must agree with this list.
 */
export const MERCHANT_TYPES = [
  "merchant",
  "personal_shopper",
  "supplier",
  "watchmaker",
];

export const isMerchantType = (type) => MERCHANT_TYPES.includes(type);

const DataHelper = {
  BAGS_CATEGORY_ID: 3,
  CIGARS_CATEGORY_ID: 4,
  WATCHES_CATEGORY_ID: 9,
  REWARD_CATEGORY_ID: 12,

  classifications: [
    { id: "investment", name: "Investment" },
    { id: "rare", name: "Rare find" },
    { id: "exclusive", name: "Local exclusivity" },
    { id: "hot", name: "Hot Piece" },
  ],

  months: [
    { id: "january", name: "January" },
    { id: "february", name: "February" },
    { id: "march", name: "March" },
    { id: "april", name: "April" },
    { id: "may", name: "May" },
    { id: "june", name: "June" },
    { id: "july", name: "July" },
    { id: "august", name: "August" },
    { id: "september", name: "September" },
    { id: "october", name: "October" },
    { id: "november", name: "November" },
    { id: "december", name: "December" },
  ],

  availability: [
    { id: "available", name: "Available Now" },
    { id: "preorder", name: "Pre-order" },
    { id: "new_collection", name: "On Request" },
  ],

  MANUAL_COMPANY_ADDRESS,
  MANUAL_WORK_TITLE,
  workTitles: [
    MANUAL_WORK_TITLE,
    "Customer Service Representative",
    "Client Advisor",
    "Sales Advisor",
    "Senior Sales Advisor",
    "Team Leader",
    "Supervisor",
    "Floor Leader",
    "Floor Manager",
    "Department Manager",
    "Universe Manager",
    "Assistant Store Manager",
    "Store Manager",
    "Store Director",
    "Sales Manager",
    "Retail Manager",
    "Area Manager",
    "General Manager",
    "General Director",
    "Brand Manager",
    "International Retail Director",
    "International Sales Director",
    "Business Introducer",
    "Assistant Buyer",
    "Buyer",
  ],
  userType: [
    { id: "store_admin", name: "Store Admin" },
    { id: "client", name: "Client" },
    { id: "merchant", name: "Merchant" },
    { id: "personal_shopper", name: "Personal Shopper" },
    { id: "supplier", name: "Supplier" },
    // A repair partner a watch is physically handed to. Filed under Merchant
    // like Supplier and Personal Shopper — see the type checks in BusinessForm,
    // UserDetailDrawer/Panel and UsersPage.onContactCreated, and
    // User::MERCHANT_GROUP_TYPES on the backend.
    { id: "watchmaker", name: "Watchmaker" },
    { id: "expert", name: "Expert" },
    { id: "concierge", name: "Concierge" },
  ],
  environments: [
    { id: "boutique", name: "BOUTIQUE" },
    { id: "showroom", name: "SHOWROOM" },
    { id: "department_store", name: "DEPARTMENT STORE" },
    { id: "headquarters", name: "HEADQUARTERS" },
  ],
  dealers: [
    { id: "small", name: "Small" },
    { id: "expert", name: "Expert" },
    { id: "pro", name: "Pro" },
  ],
  duties: [
    { id: "management", name: "MANAGEMENT" },
    { id: "sales", name: "SALES" },
  ],
  investor_type: [
    { id: "not_interested", name: "Not Interested" },
    { id: "prospective", name: "Prospective" },
    { id: "collective", name: "Collective" },
    { id: "committed", name: "Committed" },
  ],
  prospect_type: [
    { id: "high_potential", name: "High Potential" },
    { id: "none", name: "None" },
  ],
};

export default DataHelper;
